function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M480 384v32H32v-32l24-18c24-25 26-82 38-142C118 104 224 64 224 64c0-17 15-32 32-32 18 0 32 15 32 32 0 0 109 40 133 160 12 60 14 117 38 142zM256 512c36 0 64-28 64-64H192c0 36 29 64 64 64z"
}));